import makeStyles from '@mui/styles/makeStyles';
import { FONT_COLOR, FONT_COLOR_SECONDARY } from 'utils/constants';

export const useStyles = makeStyles({
	textField: {
		color: FONT_COLOR,
		background: '#fff',

		'& .MuiInputBase-input': {
			paddingLeft: '45px',
		},
		'& .MuiFormLabel-root:not(.Mui-focused):not(.MuiFormLabel-filled)': {
			transform: 'translate(45px, -50%)',
			color: FONT_COLOR_SECONDARY,
		},
	},
	searchButton: {
		cursor: 'default',
		position: 'absolute',
		left: '0',
		pointerEvents: 'none',
	},
	autocompleteSearchField: {
		flex: 2,
		marginRight: '24px',
		overflow: 'visible',

		'&.MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root': {
			paddingRight: '16px',
		},
		'&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
			paddingRight: '16px',
		},
		'& .MuiInputLabel-root:not(.Mui-focused)': {
			top: '-4px',
		},
		'& .MuiOutlinedInput-root': {
			padding: '0',
		},
		'& .MuiOutlinedInput-root .MuiAutocomplete-input': {
			padding: '12px 16px',
		},
	},
});
